import React from 'react';

export default class Enemies extends React.Component {
    static propTypes = {};
    render() {
        return (
            <div className="enemies-wrapper">
                <div className="enemies" />
            </div>
        );
    }
}

